<template>
  <div>
    <div
      :class="{'is-mobile': isMobile}"
      v-if="isMobile"
    >
      <div class="teq-container">
        <div
          class="list"
        >
          <div
            class="item"
            v-for="(item, index) in items"
            :key="index"
          >
            <div class="date">
              {{ item.date }}
            </div>
            <div
              class="title"
            >
              {{ item.title }}
            </div>

            <div
              class="image-container"
            >
              <img :src="item.image">
              <div
                class="text"
                v-html="item.text"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="teq-container"
      :class="{'is-desktop': !isMobile}"
      v-if="!isMobile"
    >
      <div
        class="list"
      >
        <div
          class="item"
          v-for="(item, index) in items"
          :key="index"
          :class="{'is-active': activeIndex == index}"

          @click="isActive(index)"
        >
          <div class="title-content">
            <div
              class="title"
              :class="{'is-active': activeIndex == index}"
            >
              {{ item.title }}
            </div>
            <div class="date">
              {{ item.date }}
            </div>
          </div>
          <div
            class="text"
            v-html="items[activeIndex].text"
          />
        </div>
      </div>
    </div>
    <div
      class="image-container"
      v-if="!isMobile"
    >
      <img :src="items[activeIndex].image">
    </div>
  </div>
</template>

<script>
export default {

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeIndex: 0,
      imageSelected: null,
    }
  },

  computed: {
    isMobile() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) return true
      return false
    },
  },


  methods: {
    isActive(index) {
      this.activeIndex = index
      this.imageSelected = this.items.length > 0 ? this.items[index].image : null
    },
  },
}
</script>
